"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _getUrlFromProps = require("../../resources/functions/getUrlFromProps");

var _Module = _interopRequireDefault(require("../Module/Module"));

require("./FinderModule.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class FinderModule extends _react.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getMetadata", () => {
      let _this$props = this.props,
          metadata = _this$props.metadata,
          size = _this$props.size,
          mediaWidth = _this$props.mediaWidth,
          mediaHeight = _this$props.mediaHeight,
          mediaSize = _this$props.mediaSize;

      if (metadata) {
        return metadata;
      }

      metadata = [];
      size = size || mediaWidth && mediaHeight && mediaWidth + "×" + mediaHeight || undefined;

      if (size) {
        metadata.push(size);
      }

      return metadata;
    });

    _defineProperty(this, "getLabel", model => {
      let _this$props2 = this.props,
          label = _this$props2.label,
          documentType = _this$props2.documentType,
          mediaType = _this$props2.mediaType,
          mimeType = _this$props2.mimeType;
      return label || mediaType || documentType || undefined;
    });

    _defineProperty(this, "formatSize", (bytes, decimals) => {
      if (bytes === 0) return '0 Bytes';
      var k = 1024,
          dm = decimals || 2,
          sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
          i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    });

    _defineProperty(this, "getModel", () => {
      const _this$props3 = this.props,
            urlPattern = _this$props3.urlPattern,
            editUrlPattern = _this$props3.editUrlPattern,
            refsUrlPattern = _this$props3.refsUrlPattern;
      const _this$props4 = this.props,
            url = _this$props4.url,
            editUrl = _this$props4.editUrl,
            refsUrl = _this$props4.refsUrl;
      return _extends({}, this.props, {
        label: this.getLabel(),
        metadata: this.getMetadata(),
        url: url || (0, _getUrlFromProps.getUrlFromProps)(this.props, urlPattern) || undefined,
        editUrl: editUrl || (0, _getUrlFromProps.getUrlFromProps)(this.props, editUrlPattern) || undefined,
        refsUrl: refsUrl || (0, _getUrlFromProps.getUrlFromProps)(this.props, refsUrlPattern) || undefined
      });
    });
  }

  render() {
    const model = this.getModel();
    const moduleLayout = model.moduleLayout;
    return _react.default.createElement(_Module.default, model);
  }

}

_defineProperty(FinderModule, "defaultProps", {
  moduleLayout: "list",
  moduleSize: "auto"
});

FinderModule.propTypes = process.env.NODE_ENV !== "production" ? {
  uniqueId: _propTypes.default.string,
  imageUrl: _propTypes.default.string,
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  label: _propTypes.default.string,
  metadata: _propTypes.default.array,
  createdAt: _propTypes.default.string,
  updatedAt: _propTypes.default.string
} : {};
var _default = FinderModule;
exports.default = _default;
module.exports = exports.default;